module.exports = __webpack_public_path__ + "static/media/counter_icon.d34d14bb.svg";